export const stylePrejoin = {
    readyjoin: {
        fontSize: '1.2rem',
        color: '#000',
        textAlign: 'start',
        marginTop: '10px',
        fontWeight: 'bold'
    },
    maxParticipantStyle: {
        fontSize: '1rem',
        color: '#000',
        marginTop: '10px',
        fontWeight: 'bold',
        textAlign: 'center'

    },
    readySpan: {
        backgroundColor: '#4e6372',
        color: '#fff',
        padding: '8px 16px',
        borderRadius: '20px',
        display: 'inline-flex'
    },
    readySpan1: {
        backgroundColor: '#F8FBFF',
        color: '#000',
        padding: '8px 16px',
        borderRadius: '10px',
        display: 'inline-flex',
        width: 'max-content',
        border: '1px solid #c7d5e9',
        gap: '5px'
    },
    readyIconSpan: {
        marginTop: '2px',
        paddingLeft: '2px',
        color: 'black',
        fontSize: 'small'
    },
    readyForm: {
        width: '90%',
        margin: 'auto',
        marginTop: '15px',
        marginBottom: '30px'
    },
    readyh4: {
        fontSize: '1.5rem',
        color: '#000',
        marginBottom: '5px'
    },
    readyStrong: {
        fontSize: '12px',
        color: '#000'
    },
    alignCenter: {
        width: '80%',
        maxWidth: '800px',
        borderRadius: '10px',
        margin: 'auto',
        backgroundColor: '#f6f6f6',
        color: '#000',
        padding: '20px',
        marginTop: '51px'
    },
    loadingImg: { width: '80px' },
    h4Style: {
        marginTop: '10px',
        color: '#000',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '1.5rem',
        fontWeight: '500',
        lineHeight: '1.2'
    },
    iconStyle: {
        margin: 'none'
    },
    margin20: {},
    inputBoxName: {
        border: '1px solid #b5cbeb',
        backgroundColor: '#fff',
        borderRadius: '10px',
        width: '50%',
        padding: '5px',
        height: 'unset',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    inputBoxEmail: {
        border: '1px solid #b5cbeb',
        backgroundColor: '#fff',
        borderRadius: '10px',
        width: '100%',
        padding: '5px',
        height: 'unset',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
};
